import styled from "styled-components";
import theme from "~/styles/theme";

export const Container = styled.div<{ showTooltip: boolean; hasNotification: boolean; isActionLink: boolean }>`
    position: relative;

    .tooltip-content {
        cursor: ${({ isActionLink }) => (isActionLink ? "pointer" : "")};
        padding: 0.8rem;
        background: #1d1d1d;
        padding: 7px;
        border-radius: 5px;
        position: absolute;
        min-width: 250px;
        max-width: 250px;
        display: ${({ showTooltip, hasNotification }) => (showTooltip && hasNotification ? "block" : "none")};
        text-align: left;
        left: -13.5rem;
        top: ${({ hasNotification, isActionLink }) => (hasNotification && isActionLink ? "-2rem" : "-3.2rem")};
        border: 1px solid #1d1d1d;

        &:before {
            content: "";
            height: 3px;
            width: 0;
            border: 7px solid transparent;
            border-top-color: #1d1d1d;
            position: absolute;
            bottom: -18px;
            right: ${({ hasNotification }) => (hasNotification ? "14px" : "8px")};
        }

        .msg {
            p {
                color: #fff;
                max-width: 250px;
                overflow: hidden;
                white-space: ${({ isActionLink }) => (isActionLink ? "nowrap" : "")};
                text-overflow: ellipsis;
            }

            &:hover {
                p {
                    color: ${({ isActionLink }) => (isActionLink ? theme.color.primary.background : "")};
                }
            }
        }
    }
`;
